import React from 'react';

import FileItem from './FileItem';
import { Container, EmptyText } from './styles';

export interface FilesListProps {
  files: Array<ApiFile>;
  onDeleteFile?: (imagePk: number) => void;
  isDeleteDisabled?: boolean;
  emptyText?: string;
  dataCy?: string;
}

const FilesList: React.FC<FilesListProps> = ({
  files,
  onDeleteFile,
  isDeleteDisabled,
  emptyText = 'Nenhum arquivo anexado',
  dataCy,
}) => {
  const isEmpty = files.length === 0;

  if (isEmpty) {
    return (
      <EmptyText>
        <em>{emptyText}</em>
      </EmptyText>
    );
  }

  return (
    <Container>
      {files.map((file, index) => (
        <FileItem
          dataCy={`${dataCy}-file-item-${index}`}
          key={file.id}
          file={file}
          onDeleteFile={onDeleteFile}
          isDeleteDisabled={isDeleteDisabled}
        />
      ))}
    </Container>
  );
};

export default FilesList;
